<template>
  <v-list class="scrollable">
    <v-list-item
      v-for="bookmark in bookmarkList"
      :key="bookmark.repo.id"
      :to="`/books/${bookmark.repo.id}`"
    >
      <v-list-item-content>
        <v-list-item-title>{{ bookmark.repo.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "BookmarkList",
  data() {
    return {
      bookmarkList: []
    };
  },
  async created() {
    this.bookmarkList = await this.$ioc.bookmarkService.getBookmarkList();
  },
  components: {}
};
</script>
